module.exports = __webpack_public_path__ + "images/img-26BPbw_.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/final.jpg
// module id = 2009
// module chunks = 0